
import axios from "axios";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {EntwurfListenEintragFromBackend} from "@k/js/databaseInterfaceClasses";
import {sendPostRequest} from "@k/global/axiosFormWrapper";

export default {
    namespaced:true,
    state: () => ({
        entwuerfe: [] as EntwurfListenEintragFromBackend[],
        currentlySelectedDraftSaveID:-1
    }),
    getters: {
        getEntwurfListe(state): EntwurfListenEintragFromBackend[] {
            return state.entwuerfe;
        },
        // getEntwurflistenEintrag:(state)=>saveID=>state.entwuerfe.find(e=>e.SaveID === saveID),
        userHasDrafts(state):boolean {
            return state.entwuerfe.length>0;
        },
        getCurrentlySelectedDraft(state):null|EntwurfListenEintragFromBackend {
            return state.entwuerfe.find(e=>e.SaveID === state.currentlySelectedDraftSaveID) || null;
        }
    },
    mutations: {
        SET_ENTWURF_LISTE: (state, entwuerfe) => {
            state.entwuerfe = entwuerfe
        },
        ADD_NEW_ENTWURFLISTENENTRY: (state, payload) => {
            state.entwuerfe.unshift(payload);
            if(state.currentlySelectedDraftSaveID === -1) {
                state.currentlySelectedDraftSaveID = state.entwuerfe[0].SaveID;
            }
        },
        SET_NEWNAME_TO_ENTWURF:(state, palyoad:{saveID, newName})=>{
            const entwurf = state.entwuerfe.find(e=>e.SaveID === palyoad.saveID);
            if(entwurf === undefined) {
                return;
            }
            entwurf.Name = palyoad.newName;
        },
        REMOVE_ENTWURF_FROM_LIST:(state, saveID)=>{
            state.entwuerfe = state.entwuerfe.filter(e=>e.SaveID !== saveID);
            if(state.currentlySelectedDraftSaveID === saveID) {
                state.currentlySelectedDraftSaveID = state.entwuerfe[0]?.SaveID || -1;
            }
        },
        SET_CURRENTLY_SELECTED_DRAFT_SAVE_ID:(state, saveID:number) =>state.currentlySelectedDraftSaveID = saveID,
    },
    actions: {
        loadEntwurfListe(context) {
            axios(
                {
                    url: "/konfigurator_php/actionmodul/loadEntwuerfe.php",
                    data: {iso: context.getters.getLanguage},
                    method: "GET",
                }
            ).then((response) => {
                context.commit("SET_ENTWURF_LISTE", response.data.drafts);
                if(response.data.drafts.length === 0) {
                    context.commit("SET_CURRENTLY_SELECTED_DRAFT_SAVE_ID", -1);
                } else {
                    if(context.getters.getCurrentlySelectedDraft === null) {
                        context.commit("SET_CURRENTLY_SELECTED_DRAFT_SAVE_ID", response.data.drafts[0].SaveID);
                    }
                }
                context.commit("SET_DERIVED_USER_DATAPATH", response.data.derivedUserDataPath, {root: true})

            })
        },

        changeEntwurfName(context, payload: { saveID, newName }) {
            sendPostRequest("/konfigurator_php/actionmodul/updateEntwurfName.php", payload)
                .then((response) => {
                    if (response.data.success === true) {
                        context.commit("SET_NEWNAME_TO_ENTWURF", payload);
                    } else {
                        EventVerteiler.broadcast("entwurfNameChangeFailedEvent", payload);
                    }
                }
            );
        },
        deleteSavedEntwurf(context, saveID:number) {
            sendPostRequest("/konfigurator_php/actionmodul/deleteEntwurf.php", {saveID: saveID})
                .then((response)=> {
                    if(response.data==="draftInShop"){
                        EventVerteiler.broadcast("displayDialogEvent", {dialog: "draftInShop"});
                    }
                    else if(response.data==="draftIsRdyDesign"){
                        EventVerteiler.broadcast("displayDialogEvent", {dialog: "draftIsRdyDesign"});
                    }
                    else{
                        context.commit("REMOVE_ENTWURF_FROM_LIST", saveID);
                    }
                });
        }
    }
}
